var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSafetyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_162_2374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.4643 81.0762C19.1328 81.0762 0.964844 62.9082 0.964844 40.5757C0.964844 18.2431 19.1328 0.0761719 41.4643 0.0761719C63.7959 0.0761719 81.9648 18.2441 81.9648 40.5757C81.9648 62.9072 63.7969 81.0762 41.4643 81.0762ZM41.4643 3.3457C20.9355 3.3457 4.23437 20.0468 4.23437 40.5757C4.23437 61.1045 20.9355 77.8056 41.4643 77.8056C61.9932 77.8056 78.6943 61.1035 78.6943 40.5757C78.6943 20.0478 61.9932 3.3457 41.4643 3.3457Z",
    fill: "#0086FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2516 30.0103C62.2401 29.4219 61.9137 28.8854 61.397 28.6047L42.2446 18.2088C41.7581 17.9447 41.1717 17.9447 40.6852 18.2088L21.5327 28.6047C21.0161 28.8854 20.6896 29.4219 20.6782 30.0103C20.5202 38.1919 22.1929 45.1457 25.6506 50.6774C29.0074 56.049 34.116 60.199 40.8339 63.0132C41.0355 63.0974 41.2507 63.1401 41.4659 63.1401C41.6811 63.1401 41.8953 63.0974 42.098 63.0132C48.8159 60.198 53.9244 56.0479 57.2813 50.6774C60.7379 45.1457 62.4106 38.1919 62.2537 30.0103H62.2516ZM41.4649 59.7271C29.6582 54.5416 23.9165 45.1384 23.9373 31.0197L41.4649 21.5053L58.9925 31.0197C59.0132 45.1384 53.2716 54.5416 41.4649 59.7271Z",
    fill: "#0086FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7674 39.4208C35.129 38.7824 34.0936 38.7824 33.4553 39.4208C32.817 40.0591 32.817 41.0945 33.4553 41.7328L37.6698 45.9473C37.989 46.2665 38.4069 46.4266 38.8258 46.4266C39.2448 46.4266 39.6627 46.2665 39.9819 45.9473L49.4734 36.4558C50.1117 35.8175 50.1117 34.7821 49.4734 34.1438C48.8351 33.5055 47.7996 33.5055 47.1613 34.1438L38.8258 42.4792L35.7674 39.4208Z",
    fill: "#0086FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_162_2374"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 81,
    height: 81,
    fill: "white",
    transform: "translate(0.964844 0.0761719)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafetyIcon);
export default __webpack_public_path__ + "static/media/safety-icon.29b9b2317a207b5234dfa2b010cf3690.svg";
export { ForwardRef as ReactComponent };